"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _components = require("components");

var _Button = require("../../EpicEula/components/Button");

var _Button2 = _interopRequireDefault(_Button);

var _LoginFailedModule = require("./LoginFailed.module.scss");

var _LoginFailedModule2 = _interopRequireDefault(_LoginFailedModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isUrl = function isUrl(item) {
  var urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

  return item.match(urlRegex) !== null;
};

var urlify = function urlify(text) {
  var lineBreakReplaced = text.replaceAll("\n", " <br/> ");
  var items = lineBreakReplaced.split(" ");

  var elements = [];
  var concat = "";

  items.forEach(function (item) {
    if (item === "<br/>") {
      elements.push(concat);
      elements.push(_react2.default.createElement(
        "div",
        null,
        _react2.default.createElement("br", null),
        _react2.default.createElement("br", null)
      ));
      concat = "";
    } else if (isUrl(item)) {
      elements.push(concat);
      elements.push(_react2.default.createElement(
        "div",
        { className: _LoginFailedModule2.default.loginLink },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: _LoginFailedModule2.default.link, target: "_blank", to: item },
          item
        ),
        " "
      ));
      concat = "";
    } else {
      concat = concat + " " + item + " ";
    }
  });

  if (concat !== "") {
    elements.push(concat);
  }

  return elements;
};

var LoginFailed = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(LoginFailed, _React$Component);

  function LoginFailed(props) {
    (0, _classCallCheck3.default)(this, LoginFailed);
    return (0, _possibleConstructorReturn3.default)(this, (LoginFailed.__proto__ || (0, _getPrototypeOf2.default)(LoginFailed)).call(this, props));
  }

  (0, _createClass3.default)(LoginFailed, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _components.Popup,
          null,
          _react2.default.createElement(
            _components.Popup.Header,
            null,
            "LOGIN FAILED"
          ),
          _react2.default.createElement(
            _components.Popup.Content,
            null,
            urlify(this.props.message)
          ),
          _react2.default.createElement(
            _components.Popup.Footer,
            null,
            _react2.default.createElement(
              "div",
              { className: _LoginFailedModule2.default.btnContainer },
              _react2.default.createElement(_Button2.default, {
                className: _LoginFailedModule2.default.button,
                primary: true,
                small: true,
                label: "Ok",
                onClick: function onClick() {
                  _this2.props.onCloseYes();
                }
              })
            )
          )
        )
      );
    }
  }]);
  return LoginFailed;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = LoginFailed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginFailedPopup/LoginFailed.jsx
// module id = 2858
// module chunks = 0